<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import OrderStatisticsPanel from "@/components/order-statistics-panel.vue";

/**
 * Dashboard component
 */
export default {
  components: { Layout, PageHeader, OrderStatisticsPanel },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Nazox",
        },
        {
          text: "Dashboard",
          active: true,
        },
      ],
      cpuused: 50,
      cpu_progresscolor: "#20a53a",
      memory: 0,
      memory_progresscolor: "#20a53a",
      hostname: "",
      statistics: [],
      salesStats: null,
      options: {
        chart: {
          id: "dashchart",
        },
        xaxis: {
          categories: [],
        },
      },
      series: [],
      userinfo: [],
      iplist: {
        ipv4: [],
        ipv6: "",
      },
      noticelist: [],
      timer: null,
      todolist: [],
      stocklist: [],
      dialogVisible: false,
      form: {
        oldPassword: 'admin',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        newPassword: [
          { required: true, message: this.$t('home.password.newpassword_tip'), trigger: 'blur' },
          { min: 6, message: this.$t('home.password.newpassword_length'), trigger: 'blur' },
          { validator: this.validateNewPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: this.$t('home.password.newpassword_check_tip'), trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      },
      otp_status: false,
      stock_status: [],
      remainingDays: null
    };
  },
  computed: {
    // 临近过期：剩余天数 ≤ 30 天，使用醒目横幅
    isLicenseNearExpiry() {
      return this.remainingDays !== null && this.remainingDays <= 30;
    },
    // 不足 7 天时显示明确续费提示
    isLicenseExpiringSoon() {
      return this.remainingDays !== null && this.remainingDays < 7;
    },
    licenseAlertTitle() {
      if (this.remainingDays === null) return "";
      if (this.remainingDays <= 0) {
        return this.$t("dashboard.license_expired");
      }
      return this.$t("dashboard.license_expiring", { days: this.remainingDays });
    }
  },
  mounted() {
    var that = this;
    that.getotpstatus();
    that.title = that.$t("dashboard.text");
    that.items = [
      {
        text: that.$t("dashboard.text"),
        href: "/",
      },
    ];
    that.userinfo = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("notice")) {
      that.noticelist = JSON.parse(localStorage.getItem("notice"));
    }
    
    // 确保数组不为null
    that.todolist = that.todolist || [];
    that.stocklist = that.stocklist || [];
    that.salesStats = that.salesStats || null;
    
    that.timer = setInterval(() => {
      that.getsalesdata();
      that.getStockStatus();
      that.getStockStatus();
    }, 4000);
    that.updateprintersetting();
    that.gettodolist();
    that.getsalesdata();
    that.getStockStatus();
    that.getLicenseInfo();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getLicenseInfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getlicenseinfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200 && response.data.data) {
            const licenseData = response.data.data;
            if (licenseData.expire_date !== undefined && licenseData.expire_date !== null) {
              that.remainingDays = Math.max(0, Number(licenseData.expire_date));
            }
          }
        })
        .catch(function () {
          // 获取失败时不展示剩余天数
        });
    },
    handdleMsg(msg) { },
    getsalesdata() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getsalesdata",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.salesStats = response.data.data || null;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    gettodolist() {
      var that = this;
      that.todolist = [];
      that.$axios
        .post(
          that.apiuri,
          {
            action: "gettodolist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.todolist = response.data.data || [];
          // 查找todolist中有没有type=account，msg包含password的数据
          var account = that.todolist.find((item) => {
            return item.type === "account" && item.msg.includes("password");
          });
          if (account) {
            that.dialogVisible = true;
          }
        })
        .catch(function (error) {
          // console.log(error);
        });

      // console.log(that.$t("menuitems.clouds.printer.text"))
    },
    getStockStatus() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_hd_stock_status",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.stocklist = response.data.data || [];
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    updateprintersetting() {
      var that = this
      that.$axios
        .post(
          that.apiuri,
          {
            action: "reloadprinter"
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          // that.getprintersetting();
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 执行密码修改逻辑
          if (this.otp_status) {
            this.$prompt(
              this.$t("setting.system.otpbind_input"),
              this.$t("setting.system.otpbind_confirm"),
              {
                confirmButtonText: this.$t("global.button.ok"),
                cancelButtonText: this.$t("global.button.cancel"),
                inputPattern: /^[0-9]{6}$/,
                inputErrorMessage: this.$t("setting.system.otpbind_input_error"),
              }
            ).then(({ value }) => {
              this.$axios.post(this.apiuri, {
                action: "checkotptoken_online",
                code: value
              },
                {
                  headers: { Openid: this.userinfo.openid },
                }
              ).then((response) => {
                if (response.data.status === 200) {
                  this.sendPasswordChange();
                } else {
                  this.$message({
                    message: this.$t("setting.system.otpcheck_failed"),
                    type: "error",
                  });
                }
              }).catch((error) => {
                this.$message({
                  message: this.$t("setting.system.otpbind_error"),
                  type: "error",
                });
              });
            }).catch(() => { });
          } else {
            this.sendPasswordChange();
          }

        } else {
          this.$message.error(this.$t('global.form.validate_failed'));
          return false;
        }
      });
    },
    validateNewPassword(rule, value, callback) {
      const lengthValid = value.length > 6;
      const hasLetter = /[a-zA-Z]/.test(value);
      const hasDigit = /\d/.test(value);
      const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);
      const hasUpperCase = /[A-Z]/.test(value);

      const typesCount = [hasLetter, hasDigit, hasSymbol, hasUpperCase].filter(Boolean).length;

      if (!lengthValid) {
        callback(new Error(this.$t('home.password.newpassword_length')));
      } else if (typesCount < 3) {
        callback(new Error(this.$t('home.password.newpassword_type')));
      } else {
        callback();
      }
    },
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.form.newPassword) {
        callback(new Error(this.$t('home.password.newpassword_double')));
      } else {
        callback();
      }
    },
    sendPasswordChange() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "changeadminpwd",
            password: that.form.confirmPassword,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.gettodolist();
          if (response.data.status == 200) {
            that.dialogVisible = false;
            that.$message.success(that.$t('home.password.success'));
          } else {
            that.$message.error(response.data.msg);
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getotpstatus() {
      this.$axios
        .post(this.apiuri, { action: 'getotpstatus' })
        .then((response) => {
          if (response.data.status === 200) {
            this.otp_status = true;
          }
        })
        .catch((error) => {
          console.error('获取 OTP 状态失败:', error);
        });
    },
    getStockProgressClass(percentage) {
      if (percentage < 20) return 'bg-danger';
      if (percentage < 50) return 'bg-warning';
      return 'bg-success';
    },
    getStockBadgeClass(percentage) {
      if (percentage < 20) return 'bg-danger text-white';
      if (percentage < 50) return 'bg-warning text-dark';
      return 'bg-success text-white';
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- 临近过期（≤30天）：醒目横幅展示 -->
    <div class="row mb-4" v-if="isLicenseNearExpiry">
      <div class="col-12">
        <div
          class="license-banner"
          :class="{
            'license-banner--warn': remainingDays > 0 && remainingDays <= 30,
            'license-banner--danger': remainingDays <= 0
          }"
        >
          <div class="license-banner__icon">
            <i class="ri-alarm-warning-line"></i>
          </div>
          <div class="license-banner__body">
            <div class="license-banner__label">{{ $t("dashboard.remaining_days") }}</div>
            <div class="license-banner__days">
              <span class="license-banner__num">{{ remainingDays }}</span>
              <span class="license-banner__unit">{{ $t("dashboard.remaining_days_unit") }}</span>
            </div>
            <div class="license-banner__tip" v-if="isLicenseExpiringSoon">
              {{ licenseAlertTitle }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 欢迎区域 -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="row align-items-center">
              <div :class="remainingDays !== null && !isLicenseNearExpiry ? 'col-md-7' : 'col-md-8'">
                <h4 class="mb-2 text-primary">
                  <i class="ri-dashboard-line me-2"></i>
                  {{ $t("dashboard.welcome") }}
                </h4>
                <p class="text-muted mb-0">{{ $t("dashboard.welcome_desc") }}</p>
              </div>
              <div :class="remainingDays !== null && !isLicenseNearExpiry ? 'col-md-5' : 'col-md-4'" class="text-end">
                <div class="d-flex justify-content-end flex-wrap">
                  <div class="me-3 mb-2" v-if="remainingDays !== null && !isLicenseNearExpiry">
                    <div class="text-center">
                      <div class="h4 mb-0 text-primary">{{ remainingDays }}</div>
                      <small class="text-muted">{{ $t("dashboard.remaining_days") }}</small>
                    </div>
                  </div>
                  <div class="me-3 mb-2">
                    <div class="text-center">
                      <div class="h4 mb-0 text-success">{{ todolist.length }}</div>
                      <small class="text-muted">{{ $t("dashboard.pending_tasks") }}</small>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="text-center">
                      <div class="h4 mb-0 text-warning">{{ stocklist.length }}</div>
                      <small class="text-muted">{{ $t("dashboard.stock_alerts") }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="row">
      <!-- 待办任务 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header bg-primary text-white">
            <h6 class="mb-0">
              <i class="ri-task-line me-2"></i>
              {{ $t("dashboard.waitjob") }}
            </h6>
          </div>
          <div class="card-body p-0">
            <div class="task-container">
              <el-empty :description="$t('dashboard.nostatistics')" v-if="todolist.length === 0" class="my-4"></el-empty>
              <div v-else class="task-list">
                <div v-for="(item, index) in todolist" :key="index" class="task-item">
                  <div class="d-flex align-items-start">
                    <div class="task-icon me-3">
                      <i class="ri-alert-line text-warning" v-if="item.type === 'account'"></i>
                      <i class="ri-device-line text-info" v-else-if="item.type === 'device'"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="task-content">
                        <span v-if="item.type == 'account'" class="fw-medium">
                          {{ $t("dashboard.todolist.account", { username: item.username }) }}
                        </span>
                        <span v-else-if="item.type == 'device'" class="fw-medium">
                          {{ $t("dashboard.todolist.devices", { device: item.ED_id }) }}
                        </span>
                        <div class="task-messages mt-1">
                          <span v-for="(val, idx) in (item.msg || [])" :key="idx" class="badge bg-light text-dark me-1">
                            {{ $t("dashboard.todolist." + val) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 库存状态 -->
      <div class="col-lg-8 col-md-6 mb-4">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header bg-warning text-dark">
            <h6 class="mb-0">
              <i class="ri-stock-line me-2"></i>
              {{ $t("dashboard.stockjob") }}
            </h6>
          </div>
          <div class="card-body p-0">
            <div class="stock-container">
              <el-empty :description="$t('dashboard.nostatistics')" v-if="stocklist.length === 0" class="my-4"></el-empty>
              <div v-else class="stock-list">
                <div v-for="(item, index) in stocklist" :key="index" class="stock-item">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="stock-info">
                      <h6 class="mb-1">{{ item.title }}</h6>
                      <div class="progress mb-2" style="height: 8px;">
                        <div class="progress-bar" 
                             :class="getStockProgressClass(item.remaining_percentage)"
                             :style="{ width: item.remaining_percentage + '%' }">
                        </div>
                      </div>
                      <small class="text-muted">
                        {{ $t("dashboard.todolist.stock", {
                          title: item.title,
                          free: item.remaining_percentage,
                        }) }}
                      </small>
                    </div>
                    <div class="stock-percentage">
                      <span class="badge" :class="getStockBadgeClass(item.remaining_percentage)">
                        {{ item.remaining_percentage }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 销售统计 -->
    <div class="row">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-success text-white">
            <h6 class="mb-0">
              <i class="ri-bar-chart-line me-2"></i>
              {{ $t("dashboard.statistics") }}
            </h6>
          </div>
          <div class="card-body">
            <OrderStatisticsPanel :stats="salesStats" compact />
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('home.password.default')" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item :label="$t('home.password.newpassword')" prop="newPassword">
          <el-input v-model="form.newPassword" :placeholder="$t('home.password.newpassword_tip')"
            show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('home.password.newpassword_check')" prop="confirmPassword">
          <el-input v-model="form.confirmPassword" :placeholder="$t('home.password.newpassword_check_tip')"
            show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("global.button.cancel") }}</el-button>
        <el-button type="primary" @click="submitForm">{{ $t("home.password.submit") }}</el-button>
      </div>
    </el-dialog>
  </Layout>
</template>
<style>
/* 服务剩余天数横幅 */
.license-banner {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.25rem 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid transparent;
}

.license-banner__icon {
  font-size: 2.75rem;
  line-height: 1;
  flex-shrink: 0;
}

.license-banner__body {
  min-width: 0;
}

.license-banner__label {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.15rem;
}

.license-banner__days {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  line-height: 1;
}

.license-banner__num {
  font-size: 2.75rem;
  font-weight: 700;
}

.license-banner__unit {
  font-size: 1.1rem;
  font-weight: 600;
}

.license-banner__tip {
  margin-top: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
}

.license-banner--ok {
  background: #e8f5e9;
  border-color: #c8e6c9;
  color: #1b5e20;
}

.license-banner--warn {
  background: #fff3e0;
  border-color: #ffb74d;
  color: #e65100;
  animation: license-pulse 1.6s ease-in-out infinite;
}

.license-banner--danger {
  background: #ffebee;
  border-color: #ef5350;
  color: #b71c1c;
  animation: license-pulse 1.2s ease-in-out infinite;
}

@keyframes license-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(230, 81, 0, 0.25); }
  50% { box-shadow: 0 0 0 8px rgba(230, 81, 0, 0); }
}

.license-banner--danger {
  animation-name: license-pulse-danger;
}

@keyframes license-pulse-danger {
  0%, 100% { box-shadow: 0 0 0 0 rgba(183, 28, 28, 0.3); }
  50% { box-shadow: 0 0 0 8px rgba(183, 28, 28, 0); }
}

@media (max-width: 576px) {
  .license-banner {
    padding: 1rem;
    gap: 0.85rem;
  }

  .license-banner__icon,
  .license-banner__num {
    font-size: 2.1rem;
  }
}

/* 任务容器样式 */
.task-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 1rem;
}

.task-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.task-item:last-child {
  border-bottom: none;
}

.task-icon {
  font-size: 1.25rem;
  width: 2rem;
  text-align: center;
}

.task-content {
  font-size: 0.9rem;
}

.task-messages .badge {
  font-size: 0.75rem;
}

/* 库存容器样式 */
.stock-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 1rem;
}

.stock-item {
  padding: 1rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.stock-item:last-child {
  border-bottom: none;
}

.stock-info h6 {
  font-size: 0.95rem;
  font-weight: 600;
}

.stock-percentage .badge {
  font-size: 0.8rem;
  padding: 0.5rem 0.75rem;
}

/* 进度条样式 */
.progress {
  border-radius: 10px;
  background-color: #f8f9fa;
}

.progress-bar {
  border-radius: 10px;
  transition: width 0.3s ease;
}

/* 卡片阴影效果 */
.card {
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .task-container,
  .stock-container {
    max-height: 300px;
  }
  
  .task-item,
  .stock-item {
    padding: 0.5rem 0;
  }
}

/* 滚动条样式 */
.task-container::-webkit-scrollbar,
.stock-container::-webkit-scrollbar {
  width: 6px;
}

.task-container::-webkit-scrollbar-thumb,
.stock-container::-webkit-scrollbar-thumb {
  background-color: #dee2e6;
  border-radius: 3px;
}

.task-container::-webkit-scrollbar-track,
.stock-container::-webkit-scrollbar-track {
  background-color: #f8f9fa;
}
</style>
<style scoped>
.dialog-footer {
  text-align: right;
}
</style>